import React from 'react';
import {
    Box,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    IconButton,
    Typography
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { UI_CONSTANTS } from './RequestDetailsTab.constants';

export const TextViewerPopup = ({ open, onClose, title, content, theme }) => (
    <Dialog
        open={open}
        onClose={onClose}
        maxWidth="sm"
        fullWidth
        aria-labelledby="text-viewer-dialog-title"
        PaperProps={{ sx: styles.dialogPaper }}
    >
        <DialogTitle
            id="text-viewer-dialog-title"
            sx={styles.dialogTitle(theme)}
        >
            {title}
            <IconButton
                aria-label="close"
                onClick={onClose}
                sx={styles.closeButton(theme)}
            >
                <CloseIcon />
            </IconButton>
        </DialogTitle>
        <DialogContent sx={styles.dialogContent}>
            <Box sx={styles.contentBox}>
                <Typography variant="body1">
                    {content}
                </Typography>
            </Box>
        </DialogContent>
        <DialogActions sx={styles.dialogActions}>
            <Button
                onClick={onClose}
                variant="contained"
                color="primary"
                sx={styles.actionButton}
            >
                {UI_CONSTANTS.CLOSE_BUTTON_TEXT}
            </Button>
        </DialogActions>
    </Dialog>
);

const styles = {
    dialogPaper: {
        borderRadius: '8px',
        boxShadow: '0 8px 24px rgba(0, 0, 0, 0.15)',
    },
    dialogTitle: (theme) => ({
        bgcolor: '#f0f6ff',
        color: theme.palette.primary.main,
        fontWeight: 600,
        borderBottom: '1px solid #e0e0e0',
        py: 1.5
    }),
    closeButton: (theme) => ({
        position: 'absolute',
        right: 8,
        top: 8,
        color: '#757575',
        '&:hover': {
            color: theme.palette.primary.main,
            bgcolor: 'rgba(25, 118, 210, 0.08)'
        }
    }),
    dialogContent: {
        pb: 0,
        pt: 0,
        px: 2,
        bgcolor: '#f8f9fa'
    },
    contentBox: {
        mt: 1.5,
        maxHeight: '50vh',
        overflow: 'auto',
        bgcolor: '#f5f5f5',
        p: 2,
        borderRadius: '4px',
        border: '1px solid #e0e0e0',
        wordBreak: 'break-word',
        whiteSpace: 'pre-wrap'
    },
    dialogActions: {
        bgcolor: '#f8f9fa',
        py: 1.5,
        px: 2
    },
    actionButton: {
        textTransform: 'none',
        px: 3,
        fontWeight: 500
    }
};